<!-- Start Top Header Area -->
<header class="header-area">
    <section class="top-header-area">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-8">
                    <ul class="top-header-contact-info">

                        <!--<li><a routerLink="/tracking"><i class='bx bx-box'></i> {{'Track_your_Order' | translate }}</a></li>-->
                        <!--<li><a href="tel:+96897676711" style="direction:ltr">{{'Support' | translate }}: 97676711</a></li>-->
                    </ul> 
                </div>
                <div class="col-4">
                    <div class="top-header-right">
                        <ul class="d-flex align-items-center justify-content-end">
                            <li>
                                <div class="dropdown language-switcher d-inline-block">
                                    <button class="dropdown-toggle" type="button" (click)="toggleClassLang()">
                                        <img src="{{CurrentLangSrc}}" alt="image">
                                        <span>{{CurrentLangName}} <i class='bx bx-chevron-down'></i></span>
                                    </button>
                                    <div class="dropdown-menu" [class.active]="classApplied">
                                        <button (click)="setLang()" class="dropdown-item d-flex align-items-center">
                                            <img src="{{SecondLangSrc}}" class="shadow-sm" alt="flag">
                                            <span>{{SecondLangName}}</span>
                                        </button>

                                    </div>
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Top Header Area -->
    <!-- Start Navbar Area -->
    <div class="navbar-area navbar-style-two">
        <div class="louise-responsive-nav">
            <div class="container">
                <div class="louise-responsive-menu">
                    <div class="logo">
                        <a routerLink="/">
                            <img src="assets/img/logo/logo.png" alt="logo" style="height: 45px;">
                            </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="louise-nav">
            <div class="container">
                <nav class="navbar navbar-expand-md navbar-light">
                    <a class="navbar-brand" routerLink="/">
                        <img src="assets/img/logo/logo.png" alt="logo" style="height: 45px;"></a>
                    <div class="collapse navbar-collapse mean-menu">
                        <ul class="navbar-nav ">

                            <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Home' | translate }}</a></li>

                            <li class="nav-item" *ngFor="let product of categoryData; let rowIndex = index;">


                                <a [routerLink]="['/shop', { catID: product.gnCategoryID }]" class="nav-link">

                                    <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_ItemAr  ; else other_ItemEn">
                                    </ng-template>
                                    <ng-template #other_ItemAr>{{ product.nameAr }}</ng-template>
                                    <ng-template #other_ItemEn>{{ product.name }}</ng-template>

                                </a>

                            </li>

                            <li class="nav-item"><a routerLink="/shop" class="nav-link">{{'Show_All' | translate }}</a></li>
<!-- 
                            <li class="nav-item"><a routerLink="/shop" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Drama' | translate }}</a></li>

                            <li class="nav-item"><a [routerLink]="['shop', { catID: 75}]" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Poetry' | translate }}</a></li>
                            <li class="nav-item"><a [routerLink]="['shop', { catID: 76}]" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Fiction_&_Story' | translate }}</a></li>
                            <li class="nav-item"><a [routerLink]="['shop', { catID: 77}]" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Islamic_Book' | translate }}</a></li> -->
                            <li class="nav-item"><a routerLink="/contact" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Contact_Us' | translate }}</a></li>
                        </ul>


                        <div class="others-option d-flex align-items-center">

                            <!--     <div class="option-item">
        <a routerLink="/cart" class="cart-btn"><i class='bx bx-shopping-bag'></i></a>
    </div> -->


                            <div class="option-item">

                                <ul class="wish-cart">
                                    <li>
                                        <a routerLink="/cart">
                                            <span class="cart">
                                                <span class="wish-icon">
                                                    <i class='bx bx-shopping-bag'></i>
                                                    <span class="count" *ngIf="cartProducts.length != undefined">
                                                        <b>
                                                            {{
                                                            cartProducts.length
                                                            }}
                                                        </b>
                                                    </span>
                                                </span>
                                                <span class="favorite"> &nbsp; </span>

                                                &nbsp;

                                            </span>
                                        </a>
                                    </li>
                                </ul>

                            </div>
                         

                        </div>


                    </div>
                </nav>
            </div>
        </div>

        <div class="others-option-for-responsive">
            <div class="container">
                <div class="dot-menu">
                    <div class="inner">
                        <div class="circle circle-one"></div>
                        <div class="circle circle-two"></div>
                        <div class="circle circle-three"></div>
                    </div>
                </div>



            </div>
        </div>
        </div>
</header>
<!-- End Navbar Area -->
